import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Smartphone, Share as ShareIcon, MoreVertical, PlusSquare, Sparkles } from 'lucide-react';

function StepList({ steps }) {
  return (
    <ol className="space-y-3">
      {steps.map((s, i) => (
        <li key={i} className="flex gap-3 items-start">
          <span className="w-6 h-6 rounded-full bg-primary/15 text-primary flex items-center justify-center text-xs font-semibold flex-shrink-0 mt-0.5">
            {i + 1}
          </span>
          <span className="text-sm text-text-secondary leading-relaxed">{s}</span>
        </li>
      ))}
    </ol>
  );
}

export default function Install() {
  return (
    <div className="min-h-screen bg-background pb-16">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-6">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-text-secondary hover:text-foreground mb-6 transition-colors text-sm"
          data-testid="install-back"
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>

        <div className="mb-8">
          <div className="flex items-center gap-2 text-primary text-xs uppercase tracking-widest mb-2">
            <Sparkles className="w-3.5 h-3.5" /> Install
          </div>
          <h1 className="text-3xl sm:text-4xl font-serif font-bold text-foreground mb-2" data-testid="install-title">
            Add Photog Bizkit to your phone
          </h1>
          <p className="text-text-secondary">
            Your photography business — always one tap away. Works offline. Feels native.
          </p>
        </div>

        <section
          className="bg-surface border border-border rounded-2xl p-5 sm:p-6 mb-5"
          data-testid="install-ios-card"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-primary/15 flex items-center justify-center">
              <Smartphone className="w-5 h-5 text-primary" />
            </div>
            <h2 className="text-lg sm:text-xl font-semibold text-foreground">iPhone (iOS)</h2>
          </div>
          <StepList
            steps={[
              'Open photog-bizkit.com in Safari.',
              'Tap the Share button (□↑) at the bottom of the screen.',
              'Scroll down and tap "Add to Home Screen".',
              'Tap "Add" — Photog Bizkit will appear on your home screen.',
            ]}
          />
          <div className="mt-4 flex items-center gap-2 text-xs text-text-muted">
            <ShareIcon className="w-4 h-4" /> Must be opened in <strong className="text-foreground">Safari</strong>. Chrome on iOS doesn’t support installing web apps.
          </div>
        </section>

        <section
          className="bg-surface border border-border rounded-2xl p-5 sm:p-6 mb-5"
          data-testid="install-android-card"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-primary/15 flex items-center justify-center">
              <Smartphone className="w-5 h-5 text-primary" />
            </div>
            <h2 className="text-lg sm:text-xl font-semibold text-foreground">Android</h2>
          </div>
          <StepList
            steps={[
              'Open photog-bizkit.com in Chrome.',
              'Tap the three-dots menu (⋮) in the top right.',
              'Tap "Add to Home Screen" or "Install App".',
              'Tap "Install" — Photog Bizkit will appear on your home screen.',
            ]}
          />
          <div className="mt-4 flex items-center gap-2 text-xs text-text-muted">
            <MoreVertical className="w-4 h-4" /> Chrome may also show an install banner automatically.
          </div>
        </section>

        <section
          className="bg-surface border border-border rounded-2xl p-5 sm:p-6"
          data-testid="install-desktop-card"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-primary/15 flex items-center justify-center">
              <PlusSquare className="w-5 h-5 text-primary" />
            </div>
            <h2 className="text-lg sm:text-xl font-semibold text-foreground">Desktop (Chrome, Edge)</h2>
          </div>
          <StepList
            steps={[
              'Open photog-bizkit.com in Chrome or Edge.',
              'Look for the install icon (⊞ or ⤓) in the address bar.',
              'Click "Install" — Photog Bizkit opens in its own window.',
            ]}
          />
        </section>
      </div>
    </div>
  );
}
